module.exports = __webpack_public_path__ + "img/cq_logo.4be0005c.png";